module.exports = __webpack_public_path__ + "static/img/jieshu.630f24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jieshu.png
// module id = eYSE
// module chunks = 24